import React from "react";
import useConfig from "../../hooks/useConfig";
import { Button } from "../../v2/components/ui/button";
import { V2Shell } from "../../v2/components/V2Shell";
import { Headphones, ExternalLink, Mail } from "lucide-react";

const SupportPage = () => {
  const configData = useConfig();

  return (
    <V2Shell>
      <div className="flex flex-col items-center justify-center gap-2 min-h-[60vh] w-full px-4 py-12 text-center my-auto">
        <Headphones className="w-8 h-8 text-slate-500" strokeWidth={1.75} />

        <h1 className="text-3xl sm:text-4xl font-bold text-slate-900 tracking-tight">
          Contact Support
        </h1>

        {/*
          Anchors, not buttons with window.open / window.location. Both of
          these navigate, so they are links: as buttons they announced
          themselves as buttons to a screen reader and quietly dropped
          middle-click, cmd-click and "copy link address". asChild keeps the
          button styling on a real <a>.
        */}
        <Button
          asChild
          variant="default"
          size="lg"
          className="font-bold shadow-sm rounded-xl h-11 px-8 border-0 bg-action text-white hover:bg-action-hover"
        >
          <a
            href={configData.supportUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            Click here
            <ExternalLink className="w-4 h-4 ml-2" />
          </a>
        </Button>

        <div className="flex items-center justify-center gap-2 text-sm text-slate-600 font-medium mt-2">
          <Mail className="w-4 h-4 text-slate-400" />
          <span>Email:</span>{" "}
          <a
            href={`mailto:${configData.supportEmail}`}
            className="hover:underline font-semibold"
            style={{ color: "var(--v2-action)" }}
          >
            {configData.supportEmail}
          </a>
        </div>
      </div>
    </V2Shell>
  );
};

export default SupportPage;
